import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/camera-off.vue
var s = {
	name: "DtIconCameraOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--camera-off"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Camera Off",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M.646.646a.5.5 0 0 1 .708 0l10 10a.5.5 0 0 1-.708.708l-.853-.854H2A1.5 1.5 0 0 1 .5 9V4.5A1.5 1.5 0 0 1 2 3h.293L.646 1.354a.5.5 0 0 1 0-.708ZM3.293 4H2a.5.5 0 0 0-.5.5V9a.5.5 0 0 0 .5.5h6.793L7.309 8.016a2 2 0 0 1-2.825-2.824L3.293 4Zm1.9 1.9A1 1 0 0 0 6.6 7.308L5.193 5.901ZM4.25 2a.5.5 0 0 1 .5-.5h2.5a.5.5 0 0 1 .384.18L8.734 3H10a1.5 1.5 0 0 1 1.5 1.5v3.75a.5.5 0 0 1-1 0V4.5A.5.5 0 0 0 10 4H8.5a.5.5 0 0 1-.384-.18l-1.1-1.32H4.75a.5.5 0 0 1-.5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=camera-off.js.map